
import Vue from 'vue';
import Component from 'vue-class-component';
@Component

export default class Carousel extends Vue{

  // 跳转
  loadurl(item:any){    
    var url="";
    if(item==1){
      url="https://doc.weixin.qq.com/sheet/e3_ADIAXwYpALYB8wcPGJbQXiKIpu6wb?scode=AIsAVQcAABIP2UgL9oADIAXwYpALY&tab=l9xp2h";
    }else if(item==2){
      url="https://upgrade.mingyuanyun.com/upgrade";
    }else if(item==3){
      url="https://dmc.mingyuanyun.com";
    }else if(item==4){
      url="http://z.mingyuanyun.com:10001/";
    }
    window.open(url);
  }
}
